import { mapMethods } from './api'

const ENDPOINT = 'interviewer'

export const key = 'id' 

export default {
    ENDPOINT,
    key,
    ...mapMethods(ENDPOINT, [
        'view',
        'search',
        'delete',
        'update',
        'create'
    ]),
}
